/**
 * useDeviceRemovedSocket — logout remoto imediato quando ESTE device é
 * removido em "Dispositivos conectados" (de qualquer outro aparelho).
 *
 * O backend emite `device:removed` no room `user:{userId}` ao excluir um
 * device; cada cliente compara o deviceId do payload com o seu
 * (localStorage) e desloga na hora se for o alvo. Aparelhos offline não
 * recebem o evento — o acesso deles expira com o JWT (limitação conhecida,
 * sem revogação server-side de sessão por device hoje).
 *
 * Montado exatamente 1x via `GlobalSocketListeners` (NUNCA #38).
 */

import { useEffect } from 'react';

import { useAuth } from '@/contexts/AuthContext';
import { useSocket } from '@/contexts/SocketContext';
import { getOrCreateDeviceId } from '@/lib/deviceId';

export const useDeviceRemovedSocket = (): void => {
  const { socket } = useSocket();
  const { state: authState, logout } = useAuth();

  useEffect(() => {
    if (!socket || !authState.user) return;

    const handler = (payload: { deviceId?: string }): void => {
      if (payload?.deviceId && payload.deviceId === getOrCreateDeviceId()) {
        logout();
      }
    };

    socket.on('device:removed', handler);
    return () => {
      socket.off('device:removed', handler);
    };
  }, [socket, authState.user, logout]);
};
